const countyConfigSearchReducer = (state = [{}], action) => {
  switch (action.type) {
    case 'LANDSHARK_COUNTY_CONFIG_SEARCH':
      return action.results;
    default:
      break;
  }
  return state;
}

export default countyConfigSearchReducer;